import {
  TOOL_INSPECTION_RETURN_STATUS,
  ToolInspectionReturnStatus
} from 'types/services';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

export const TOOL_INSPECTION_RETURN_STATUS_MESSAGES: Record<ToolInspectionReturnStatus, string> = {
  [TOOL_INSPECTION_RETURN_STATUS.CREATED]: 'DSN de la herramienta se ha creado con éxito',
  [TOOL_INSPECTION_RETURN_STATUS.EDITED]: 'DSN de la herramienta se ha actualizado con éxito',
  [TOOL_INSPECTION_RETURN_STATUS.CANCELLED]: 'La inspección del DSN de la herramienta ha sido cancelada'
};

export const isToolInspectionReturnStatus = (value: string): value is ToolInspectionReturnStatus =>
  (Object.values(TOOL_INSPECTION_RETURN_STATUS) as string[]).includes(value);

export const showToolInspectionReturnFeedback = (status: ToolInspectionReturnStatus): void => {
  const message = TOOL_INSPECTION_RETURN_STATUS_MESSAGES[status];
  const jsx = <>{message}</>;

  if (status === TOOL_INSPECTION_RETURN_STATUS.CANCELLED) {
    displayErrorNotification({ customJSXMessage: jsx });
    return;
  }

  displaySuccessNotification({ customJSXMessage: jsx });
};
